import { colorYiq } from "@/projectRoot/src/utils/handlers/miscHandler";

interface Props {
  width?: number;
  height?: number;
  hexColor?: string;
  fill?: boolean;
}

export const GridOneColumn = ({
  width = 7,
  height = 16,
  hexColor = "#ffffff",
  fill = false
}: Props) => {
  return (
    <svg width={width} height={height} viewBox="0 0 7 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="6.93333" height="16" rx="2" fill={hexColor} />
      <rect x="0.266667" y="0.266667" width="6.4" height="15.4667" rx="1.86667" fill={hexColor} stroke={fill ? hexColor : colorYiq(hexColor)} strokeWidth="0.533333" />
    </svg>
  );
};

export default GridOneColumn;
